import {event} from "d3-selection";

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-brush/src/noevent.js
// module id = null
// module chunks = 